export const UPDATE_SKU_TREND_WIDGET = "UPDATE_SKU_TREND_WIDGET";